module.exports = __webpack_public_path__ + "img/android-chrome-512x512.d6cbdc41.png";